/*jshint esnext: true */
/*global jQuery, dis, google, markerClusterer */

/* DIS/PLAY Script
 Author's name: Michelle Lykke - mlb@dis-play.dk
 Modified by:
 Client name: Danske Regioner
 Date of creation: 5.7.2017
 */


(function ($, dis) {
	"use strict";


	dis.GoogleMaps = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			selfScope = this;


		function initMap() {
			var mapCenter = {lat: 55.821632, lng: 10.584830};
			var mapElement = document.getElementById('map');
			var isProjectsMap = dom.container.hasClass('google-maps-container--projects');
			var mapOptions = {
				zoom: 6,
				center: mapCenter,
				styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway.controlled_access","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.highway.controlled_access","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#7391a4"},{"visibility":"on"}]}]
			};

			var map = new google.maps.Map(mapElement, mapOptions);

			var mapElements = JSON.parse(document.getElementById('map').dataset.content);

			var markers = [];
			var infoWindows = [];
			var icon = '';

			for (var i = 0; i < mapElements.length; i += 1) {
				var element = mapElements[i];
				var position;
				var elementLink;
				var title;

				if (isProjectsMap) {

					position = { lat: element.ConstructionProjectLocation.Latitude, lng: element.ConstructionProjectLocation.Longitude };
					elementLink = element.Url;
					title = element.Title;

					icon = '/static/dist/media/projects-pins/gmap_' + (element.ProjectType === "Kvalitetsfondsbyggerier" ? 'k' : 'r') + '_' + element.ConstructionPhase + '.png';

				} else {

					position = { lat: element.Coordinates.Latitude, lng: element.Coordinates.Longitude };
					elementLink = element.Link;
					if (element.MarkerUrl) {
						icon = element.MarkerUrl;
					} else {
						icon = '/static/dist/media/pin.png';
					}

				}

				var marker = new google.maps.Marker({
					position: position,
					map: map,
					icon: icon,
					title: title,
					infoWindowIndex: i
				});
				var infoWindow;


				if (isProjectsMap) {

					// Click on marker opens link
					google.maps.event.addListener(marker, 'click', function () { // jshint ignore:line
						window.location.href = mapElements[this.infoWindowIndex].Url;
					});

				} else {

					// Make info box
					var elementString = '';

					if (elementLink !== null) {
						elementString = '<p><a href="'+ elementLink.Url +'" target="' + elementLink.Target + '">' + elementLink.Name + '</a></p>';
					}

					var content = '<div>' + '<h3>' + element.Title + '</h3>' + '<p>' + element.Description + '</p>' + elementString + '</div>';
					infoWindow = new google.maps.InfoWindow({
						content: content
					});

					// Click on marker shows info box
					google.maps.event.addListener(marker, 'click', function () { // jshint ignore:line
						//map.panTo(event.latLng);
						infoWindows[this.infoWindowIndex].open(map, this);
					});

				}

				infoWindows.push(infoWindow);
				markers.push(marker);
			}


			if (isProjectsMap) {
				if (mapElements.length === 1) {

					map.setCenter({ lat: mapElements[0].ConstructionProjectLocation.Latitude, lng: mapElements[0].ConstructionProjectLocation.Longitude });
					map.setZoom(14);

				} else {

					// Zoom to country bounds
					map.fitBounds(new google.maps.LatLngBounds(
						new google.maps.LatLng(54.7246201949245, 7.679443359375),
						new google.maps.LatLng(57.89149735271034, 12.952880859375)
					));

				}
			} else {

				void new markerClusterer.MarkerClusterer(map, markers, {
					imagePath: 'https://github.com/googlemaps/v3-utility-library/blob/master/markerclusterer/images/m1.png?raw=true'
				});

			}

		}
		window.initMap = initMap;

		function init() {
			dom.container = $(configuration.container);

			if (dom.container.length) {
				initMap();
			}
		}

		selfScope.onReady(init);
	};

	dis.GoogleMaps.prototype = new dis.BaseModule();
	dis.GoogleMaps.constructor = dis.GoogleMaps;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));